import React from 'react';
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export const DialogComponent = (props) => {
  const { open, handleClose, onClick, title, description, id } = props;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ fontSize: "1.05rem" }}>
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText
          id="alert-dialog-description"
          py={3}
          sx={{ fontSize: "0.975rem" }}
        >
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={() => onClick("accept-dialog", id)} autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
